import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BidTrackerCloneChoiceComponent } from './bid-tracker-clone-choice.component';

/** Its own module because both the app shell (the nav bar's Add Bid dialog) and the lazy-loaded
 *  BidsModule (the bid page's Clone popup) use it. */
@NgModule({
  declarations: [BidTrackerCloneChoiceComponent],
  imports: [CommonModule, RouterModule],
  exports: [BidTrackerCloneChoiceComponent],
})
export class BidTrackerCloneChoiceModule { }
